import { ICamProductOptionsData } from './shared';

export const extrakteProducts: ICamProductOptionsData[] = [
    {
        "label": "10/10 Vayamed Cannabisextrakt",
        "thc_cbd": "10/10",
        "partner": "Vayamed",
        "category": "THC/CBD"
    },
    {
        "label": "10/50 Vayamed Cannabisextrakt",
        "thc_cbd": "10/50",
        "partner": "Vayamed",
        "category": "THC-/CBD"
    },
    {
        "label": "25/1 Vayamed Cannabisextrakt",
        "thc_cbd": "25/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "25/25 Vayamed Cannabisextrakt",
        "thc_cbd": "25/25",
        "partner": "Vayamed",
        "category": "THC/CBD"
    },
    {
        "label": "50/1 Vayamed Cannabisextrakt",
        "thc_cbd": "50/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "Adven Extrakt 0/50",
        "thc_cbd": "0/50",
        "partner": "Four 20 Pharma",
        "category": "CBD"
    },
    {
        "label": "Adven Extrakt 10/0",
        "thc_cbd": "10/0",
        "partner": "Four 20 Pharma",
        "category": "THC"
    },
    {
        "label": "Adven Extrakt 10/10",
        "thc_cbd": "10/10",
        "partner": "Four 20 Pharma",
        "category": "THC/CBD"
    },
    {
        "label": "Adven Extrakt 20/0",
        "thc_cbd": "20/0",
        "partner": "Four 20 Pharma",
        "category": "THC"
    },
    {
        "label": "Althea Cannabis Extrakt THC10 : CBD12",
        "thc_cbd": "10/12",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "Althea Cannabis Extrakt THC2 : CBD25",
        "thc_cbd": "2/25",
        "partner": null,
        "category": "CBD"
    },
    {
        "label": "Althea Cannabis Extrakt THC20 : CBD1",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Althea Cannabis Extrakt THC5 : CBD10",
        "thc_cbd": "5/10",
        "partner": null,
        "category": "THC-/CBD"
    },
    {
        "label": "Aurora Extract 12.5:12.5",
        "thc_cbd": "12,5/12,5",
        "partner": "Aurora",
        "category": "THC/CBD"
    },
    {
        "label": "Aurora Extract 25:1",
        "thc_cbd": "25/1",
        "partner": "Aurora",
        "category": "THC"
    },
    {
        "label": "Cannabisextrakt Avextra 10/10",
        "thc_cbd": "10/10",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "Cannabisextrakt Avextra 25 THC",
        "thc_cbd": "25/0",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannabisextrakt Ethypharm CBD 100",
        "thc_cbd": "3,3/100",
        "partner": null,
        "category": "CBD"
    },
    {
        "label": "Cannabisextrakt Ethypharm CBD 200",
        "thc_cbd": "6,6/199",
        "partner": null,
        "category": "CBD"
    },
    {
        "label": "Cannabisextrakt Ethypharm THC 10 CBD 10",
        "thc_cbd": "10/10",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "Cannabisextrakt Ethypharm THC 50",
        "thc_cbd": "50/5",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "CannabiStada® Extrakt THC 1/CBD 25 CA",
        "thc_cbd": "1/25",
        "partner": "STADAPHARM",
        "category": "CBD"
    },
    {
        "label": "CannabiStada® Extrakt THC 10/CBD 10 CA",
        "thc_cbd": "10/10",
        "partner": "STADAPHARM",
        "category": "THC/CBD"
    },
    {
        "label": "CannabiStada® Extrakt THC 10/CBD 100 CA",
        "thc_cbd": "10/100",
        "partner": "STADAPHARM",
        "category": "CBD"
    },
    {
        "label": "CannabiStada® Extrakt THC 30/CBD 30 CA",
        "thc_cbd": "30/30",
        "partner": "STADAPHARM",
        "category": "THC/CBD"
    },
    {
        "label": "CannabiStada® Extrakt THC 50/CBD 25 CA",
        "thc_cbd": "50/25",
        "partner": "STADAPHARM",
        "category": "THC/CBD-"
    },
    {
        "label": "CannabiStada® Extrakt THC 25/CBD 1 CA",
        "thc_cbd": "25/1",
        "partner": "STADAPHARM",
        "category": "THC"
    },
    {
        "label": "Cannamedical Hybrid Cannabisextrakt THC25:CBD25",
        "thc_cbd": "25/25",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "Demecan 20:20 Oktonia",
        "thc_cbd": "20/20",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "Demecan 30:01 Oktonia",
        "thc_cbd": "30/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Hormosan Cannabisextrakt THC10:CBD10",
        "thc_cbd": "10/10",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "Hormosan Cannabisextrakt THC20:CBD6",
        "thc_cbd": "20/6",
        "partner": null,
        "category": "THC/CBD-"
    },
    {
        "label": "Hormosan Cannabisextrakt THC25",
        "thc_cbd": "25/0",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Hormosan Cannabisextrakt THC25:CBD25",
        "thc_cbd": "25/25",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "Hormosan Cannabisextrakt THC5:CBD20",
        "thc_cbd": "5/20",
        "partner": null,
        "category": "THC-/CBD"
    },
    {
        "label": "LGP 10:10 Classic Cannabisextrakt",
        "thc_cbd": "10/10",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "LGP 20:5 Classic Cannabisextrakt",
        "thc_cbd": "20/5",
        "partner": null,
        "category": "THC/CBD-"
    },
    {
        "label": "NAXIVA-PANAXOL CBD 25 Cannabis-Extrakt",
        "thc_cbd": "0/25",
        "partner": null,
        "category": "CBD"
    },
    {
        "label": "NAXIVA-PANAXOL THC 25 / CBD 25 Cannabis-Extrakt",
        "thc_cbd": "25/25",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "NAXIVA-PANAXOL THC 25 Cannabis-Extrakt",
        "thc_cbd": "25/0",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "NAXIVA-PANAXOL THC 50 Cannabis-Extrakt",
        "thc_cbd": "50/0",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "SOMAÍ Cannabisextrakt Hybrid 2,5:25",
        "thc_cbd": "2,5/25",
        "partner": "SOMAÍ",
        "category": "CBD"
    },
    {
        "label": "SOMAÍ Cannabisextrakt Hybrid 10:10",
        "thc_cbd": "10/10",
        "partner": "SOMAÍ",
        "category": "THC/CBD"
    },
    {
        "label": "SOMAÍ Cannabisextrakt Hybrid 25:1",
        "thc_cbd": "25/1",
        "partner": "SOMAÍ",
        "category": "THC"
    },
    {
        "label": "SOMAÍ Cannabisextrakt Hybrid 25:25",
        "thc_cbd": "25/25",
        "partner": "SOMAÍ",
        "category": "THC/CBD"
    },
    {
        "label": "SOMAÍ Cannabisextrakt Hybrid 50:01",
        "thc_cbd": "50/1",
        "partner": "SOMAÍ",
        "category": "THC"
    },
    {
        "label": "TILRAY Cannabisextrakt THC5:CBD20",
        "thc_cbd": "5/20",
        "partner": "Tilray",
        "category": "THC-/CBD"
    },
    {
        "label": "TILRAY Cannabisextrakt THC10:CBD10",
        "thc_cbd": "10/10",
        "partner": "Tilray",
        "category": "THC/CBD"
    },
    {
        "label": "TILRAY Cannabisextrakt THC20:CBD6",
        "thc_cbd": "20/6",
        "partner": "Tilray",
        "category": "THC/CBD-"
    },
    {
        "label": "TILRAY Cannabisextrakt THC25:CBD25",
        "thc_cbd": "25/25",
        "partner": "Tilray",
        "category": "THC/CBD"
    },
    {
        "label": "TILRAY Cannabisextrakt THC25",
        "thc_cbd": "25/0",
        "partner": "Tilray",
        "category": "THC"
    },
    {
        "label": "Vertanical CBD",
        "thc_cbd": "0/10",
        "partner": null,
        "category": "CBD"
    },
    {
        "label": "Vertanical THC",
        "thc_cbd": "20/0",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Vertanical THC/CBD",
        "thc_cbd": "20/20",
        "partner": null,
        "category": "THC/CBD"
    }
]
